import React from 'react';
import cn from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './CommissionPointsAndPrice.scss';
const CommissionPointsAndPrice = ({ points , price , dollarsClassName , pointsClassName  })=>{
    const shop_thumbs_price = useFlag('shop_thumbs_price');
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], shop_thumbs_price && s['shop_thumbs_price'])
    }, shop_thumbs_price && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['dollars-price'], dollarsClassName)
    }, price), points && /*#__PURE__*/ React.createElement("div", {
        className: cn(s['points-price'], pointsClassName)
    }, /*#__PURE__*/ React.createElement(PointsIcon, {
        className: s['points-icon'],
        size: IconSize.TINY,
        disableDefaultColors: true
    }), points)), !shop_thumbs_price && /*#__PURE__*/ React.createElement(React.Fragment, null, points && /*#__PURE__*/ React.createElement("div", {
        className: s['points-value']
    }, /*#__PURE__*/ React.createElement(PointsIcon, {
        className: s['points-icon'],
        size: IconSize.SMALLER
    }), points), /*#__PURE__*/ React.createElement("div", {
        className: s['dollars-cost']
    }, price)));
};
CommissionPointsAndPrice.displayName = 'CommissionPointsAndPrice';
export default CommissionPointsAndPrice;
